module.exports = __webpack_public_path__ + "static/media/KREDIVO.a8e71ef3.svg";